<script setup lang="ts">
import type { Property } from '~/core/entities/property';

import { usePropertyHeroNavigation } from '~/composables/usePropertyHeroNavigation';

import { HoverExpandButton } from '~/components/HoverExpandButton';
import { SearchSuggestSelectModal } from '~/components/SearchSuggestSelectModal';

import IconMaterialSymbolsLightArrowBack from '~icons/material-symbols-light/arrow-back';
import IconMaterialSymbolsLightSearch from '~icons/material-symbols-light/search';

interface PropertyHeroNavigationControlsProps {
	property: Property | null;
}

const props = defineProps<PropertyHeroNavigationControlsProps>();

const propertyRef = computed(() => props.property);

const { handleBackButtonClick, handleSearchBarClick } =
	usePropertyHeroNavigation({
		property: propertyRef
	});
</script>

<template>
	<div
		class="absolute left-4 top-[4.5rem] z-30 flex gap-3 md:left-5 md:top-[5.5rem] lg:left-12 lg:gap-5"
	>
		<!-- Back button -->
		<!-- This button has a quirk where you can't apply size directly because the button won't expand -->
		<HoverExpandButton
			class="max-h-10 max-w-10 justify-center lg:max-h-none lg:min-h-12 lg:min-w-12 lg:max-w-none"
			@click="handleBackButtonClick"
		>
			<template #icon>
				<IconMaterialSymbolsLightArrowBack class="size-5" />
			</template>
			<template #title>
				{{ property?.region }}
			</template>
		</HoverExpandButton>

		<SearchSuggestSelectModal :property="property">
			<HoverExpandButton
				class="size-10 justify-center lg:size-12"
				@click="handleSearchBarClick"
			>
				<template #icon>
					<IconMaterialSymbolsLightSearch class="size-5" />
				</template>
			</HoverExpandButton>
		</SearchSuggestSelectModal>
	</div>
</template>
